import { cn } from "@/core/utils/utils";

export const PROSE_CLASS = cn(
  "prose max-w-none break-words text-md",
  "prose-headings:font-semibold prose-headings:text-primary-text prose-headings:mt-4 prose-headings:mb-2",
  "prose-h1:text-xl prose-h2:text-lg prose-h3:text-base",
  "prose-p:my-2 prose-p:text-md prose-p:leading-relaxed prose-p:text-primary-text",
  "prose-blockquote:my-2 prose-blockquote:border-l-2 prose-blockquote:border-stroke-secondary prose-blockquote:not-italic prose-blockquote:text-secondary-text",
  "prose-strong:font-semibold prose-strong:text-primary-text",
  "prose-code:rounded prose-code:bg-surface-secondary prose-code:px-1 prose-code:py-0.5 prose-code:font-mono prose-code:text-xs prose-code:text-primary-text prose-code:before:content-none prose-code:after:content-none",
  "prose-pre:rounded-md prose-pre:bg-surface-secondary prose-pre:p-3 prose-pre:text-xs prose-pre:overflow-x-auto",
  "prose-ol:my-2 prose-ol:pl-4 prose-ul:my-2 prose-ul:pl-4 prose-li:my-1 prose-li:text-md prose-li:text-primary-text prose-li:leading-relaxed",
  "prose-table:my-3 prose-table:text-md prose-thead:border-stroke-secondary prose-tr:border-stroke-secondary",
  "prose-th:px-3 prose-th:py-2 prose-th:font-semibold prose-th:text-primary-text",
  "prose-td:px-3 prose-td:py-2 prose-td:text-primary-text",
  "prose-hr:border-stroke-secondary",
  "[&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
  "[&_table]:w-full [&_table]:border-collapse [&_table]:overflow-hidden [&_table]:rounded-md [&_table]:border [&_table]:border-stroke-secondary",
  "[&_thead]:bg-surface-secondary [&_tr:last-child_td]:border-b-0",
);
